import { API_BASE } from './api';

// #2331 — extracted out of PrototypeViewer.tsx (unchanged logic) so a
// second caller (the project_members-only landing page) can safely reuse
// the SAME Bearer-authenticated fetch, rather than hand-rolling a second
// copy of security-relevant logic. See PrototypeViewer.tsx's top-of-file
// comment for why this can't be a plain <a href> new-tab navigation (this
// app has no auth cookie, only a localStorage Bearer JWT) and why the
// caller must render the result in a `sandbox=""` iframe, never
// `window.open` a blob URL directly.

export interface FetchPrototypeOptions {
  download?: boolean;
  /** PIECE-0 — when set, requests the server-side role re-stamp
   *  (?roleIdx=N). Omitted entirely for the initial "Open prototype" fetch
   *  so that request is byte-for-byte identical to pre-PIECE-0 behavior. */
  roleIdx?: number;
}

export async function fetchPrototype(artefactId: string, versionId: string, opts: FetchPrototypeOptions = {}): Promise<Response> {
  const token = localStorage.getItem('blueprint_token');
  const params = new URLSearchParams();
  if (opts.download) params.set('download', '1');
  if (opts.roleIdx !== undefined) params.set('roleIdx', String(opts.roleIdx));
  const qs = params.toString();
  const url = `${API_BASE}/artefacts/${artefactId}/versions/${versionId}/prototype${qs ? `?${qs}` : ''}`;
  const res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.error ?? 'Failed to load prototype');
  }
  return res;
}

export function parsePrototypeFilename(contentDisposition: string | null, fallback: string): string {
  if (!contentDisposition) return fallback;
  const match = /filename="([^"]+)"/.exec(contentDisposition);
  return match?.[1] ?? fallback;
}
